export const loginUrl = "/login";
export const logOutUrl = "/logout";
//personal routes
export const personalUsersUrl = "/personal/users";
export const personalDatatypesUrl = "/personal/onboarding-datatypes";
export const personalReqDatatypesUrl = "/personal/requested-datatypes";
export const personalNewsletterUrl = "/personal/newsletters";
//business routes
export const businessUsersUrl = "/business/users";
export const businessDatatypesUrl = "/business/onboarding-datatypes";
export const businessServicesUrl = "/business/onboarding-services";
export const businessReqServicesUrl = "/business/requested-services";
export const businessVerificationsUrl = "/business/requested-verifications";
//roles&permissions
export const roleUsersUrl = "/roles/users";
export const roleUrl = "/roles";
export const rolePermissionsUrl = "/roles/permissions";
